(() => {
  const wireModalClosers = (modal) => {
    const closeEls = modal.querySelectorAll('[data-close-modal]');
    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
      trapFocus(e);
    };
    const getTabbables = () =>
      modal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');

    const trapFocus = (e) => {
      if (e.key !== 'Tab') return;
      const f = getTabbables();
      if (!f.length) return;
      const first = f[0];
      const last  = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    // Guardar ref para cerrar
    modal._tb_onKeyDown = onKeyDown;

    // Cierres
    closeEls.forEach(el => el.addEventListener('click', close));

    // Cerrar en overlay
    modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('measurements-modal__overlay')) close();
    });

    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('tb-lock-scroll');
      document.removeEventListener('keydown', onKeyDown);
      modal._tb_lastFocused?.focus();
    }
  };

  const init = () => {
    const modal = document.getElementById('measurements-modal');
    if (!modal) return;

    // Evitar doble init si la sección se recarga
    if (!modal.dataset.enhanced) {
      modal.dataset.enhanced = 'true';

      // --- Determinar sectionId antes de mover modal ---
      let sectionId =
        modal.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');

      if (!sectionId) {
        const gv =
          modal.closest('[id^="shopify-section-"]')?.querySelector('[id^="GalleryViewer-"]') ||
          document.querySelector('[id^="GalleryViewer-"]');
        if (gv?.id) sectionId = gv.id.replace('GalleryViewer-', '').replace('-duplicate', '');
      }
      if (!sectionId) {
        const m = document.querySelector('#tb-measures[data-section-id]');
        if (m) sectionId = m.dataset.sectionId;
      }
      if (sectionId) modal.dataset.sectionId = sectionId;
      else console.warn('[tb-measures] No sectionId');

      // Portal
      if (modal.parentElement !== document.body) document.body.appendChild(modal);

      // Delegación para abrir
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('#open-measurements-modal');
        if (!trigger) return;
        e.preventDefault();
        if (trigger.tagName === 'BUTTON' && !trigger.hasAttribute('type')) trigger.setAttribute('type', 'button');

        modal._tb_lastFocused = document.activeElement;

        if (modal.hasAttribute('hidden')) modal.removeAttribute('hidden');
        requestAnimationFrame(() => modal.classList.add('is-open'));
        document.body.classList.add('tb-lock-scroll');
        document.addEventListener('keydown', modal._tb_onKeyDown || (()=>{}));
        (modal.querySelector('.measurements-modal__close') || modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))?.focus();
      });

      // Enlazar cierres y focus-trap
      wireModalClosers(modal);

      // Sincronizar al cargar
      refreshTbMeasures();
    } else {
      // Si re-renderizaste el contenido del modal, vuelve a cablear cierres
      wireModalClosers(modal);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();






function getCurrentVariantId(root = document) {
  return root.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
}

// pequeño helper para añadir cache-buster a src y srcset
function bustImageCache(imgEl) {
  if (!imgEl) return;
  // src
  const src = imgEl.getAttribute('src');
  if (src) {
    const u = new URL(src, window.location.origin);
    u.searchParams.set('t', Date.now());
    imgEl.setAttribute('src', u.pathname + u.search);
  }
  // srcset
  const ss = imgEl.getAttribute('srcset');
  if (ss) {
    const parts = ss.split(',').map(s => s.trim()).map(entry => {
      const [urlPart, size] = entry.split(' ');
      try {
        const u = new URL(urlPart, window.location.origin);
        u.searchParams.set('t', Date.now());
        return `${u.pathname + u.search}${size ? ' ' + size : ''}`;
      } catch { return entry; }
    });
    imgEl.setAttribute('srcset', parts.join(', '));
  }
}

// Pre-cargar/decodificar la imagen antes de insertarla (evita flicker)
async function ensureImageReady(imgEl) {
  if (!imgEl) return;
  try {
    if (typeof imgEl.decode === 'function') {
      await imgEl.decode();
    } else if (!imgEl.complete) {
      await new Promise((res) => {
        imgEl.onload = () => res();
        imgEl.onerror = () => res();
      });
    }
  } catch (_) {
    // si falla decode, seguimos igualmente
  }
}

async function refreshTbMeasures() {
  const modal = document.getElementById('measurements-modal');
  if (!modal) return;

  const sectionId =
    modal.dataset.sectionId ||
    document.querySelector('#tb-measures[data-section-id]')?.dataset.sectionId ||
    document.querySelector('[id^="GalleryViewer-"]')?.id?.replace('GalleryViewer-', '').replace('-duplicate','');

  const variantId = getCurrentVariantId();
  console.log('[tb-measures] refresh -> sectionId:', sectionId, 'variantId:', variantId);

  const pageMeasures = document.querySelector('#tb-measures'); // botón en página
  const targetImgWrap = modal.querySelector('.measurements-modal__image');

  if (!sectionId) return;

  const url = new URL(window.location.href);
  if (variantId) url.searchParams.set('variant', variantId);
  url.searchParams.delete('sections');
  url.searchParams.append('sections', sectionId);
  url.searchParams.set('cb', Date.now()); // cache-buster

  try {
    const res = await fetch(`${url.pathname}?${url.searchParams.toString()}`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();
    const html = data?.[sectionId];
    if (!html) return;

    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // ---- 1) Nuevo botón (si la variante trae imagen de medidas) ----
    const freshMeasures = tmp.querySelector('#tb-measures');

    // ---- 2) Extraer la NUEVA imagen del modal desde el fragmento ----
    // Buscamos el <img> de medidas en el fragmento (esté dentro del modal o del bloque)
    const freshImgEl =
      tmp.querySelector('#measurements-modal .measurements-modal__image img') ||
      tmp.querySelector('#tb-measures .measurements-modal__image img') ||
      tmp.querySelector('.measurements-modal__image img');

    // Si hay nueva imagen, recopila atributos
    let nextAttrs = null;
    if (freshImgEl) {
      nextAttrs = {
        src: freshImgEl.getAttribute('src') || '',
        srcset: freshImgEl.getAttribute('srcset') || '',
        sizes: freshImgEl.getAttribute('sizes') || '',
        alt: freshImgEl.getAttribute('alt') || '',
        width: freshImgEl.getAttribute('width') || '',
        height: freshImgEl.getAttribute('height') || ''
      };

      // Si el src es igual al actual, añade cache-buster ANTES de precargar
      const currentImg = targetImgWrap?.querySelector('img');
      const oldSrc = currentImg?.getAttribute('src') || '';
      if (oldSrc && nextAttrs.src && oldSrc === nextAttrs.src) {
        const u = new URL(nextAttrs.src, window.location.origin);
        u.searchParams.set('t', Date.now());
        nextAttrs.src = u.pathname + u.search;

        if (nextAttrs.srcset) {
          const parts = nextAttrs.srcset.split(',').map(s => s.trim()).map(entry => {
            const [urlPart, size] = entry.split(' ');
            try {
              const uu = new URL(urlPart, window.location.origin);
              uu.searchParams.set('t', Date.now());
              return `${uu.pathname + uu.search}${size ? ' ' + size : ''}`;
            } catch { return entry; }
          });
          nextAttrs.srcset = parts.join(', ');
        }
      }
    }

    // ---- Precarga de la nueva imagen (si existe) ----
    if (nextAttrs && nextAttrs.src) {
      const preload = new Image();
      if (nextAttrs.srcset) preload.srcset = nextAttrs.srcset;
      if (nextAttrs.sizes) preload.sizes = nextAttrs.sizes;
      preload.src = nextAttrs.src;
      try { await preload.decode?.(); } catch (_) {}
    }

    // ---- APLICAR cambios en un solo frame (imagen + botón) ----
    const viewer =
      document.getElementById(`GalleryViewer-${sectionId}`) ||
      document.querySelector(`[id^="GalleryViewer-${sectionId}"]`);

    requestAnimationFrame(() => {
      // Imagen del modal: actualizar el <img> directamente
      if (targetImgWrap) {
        let img = targetImgWrap.querySelector('img');
        if (nextAttrs && nextAttrs.src) {
          if (!img) {
            img = document.createElement('img');
            targetImgWrap.appendChild(img);
          }
          // set atributos (orden: srcset/sizes antes que src)
          if (nextAttrs.alt) img.setAttribute('alt', nextAttrs.alt);
          if (nextAttrs.width) img.setAttribute('width', nextAttrs.width);
          if (nextAttrs.height) img.setAttribute('height', nextAttrs.height);
          if (nextAttrs.sizes) img.setAttribute('sizes', nextAttrs.sizes);
          if (nextAttrs.srcset) img.setAttribute('srcset', nextAttrs.srcset);
          img.setAttribute('loading', 'eager');
          img.setAttribute('src', nextAttrs.src);
        } else {
          // no hay imagen para esta variante → limpiamos
          targetImgWrap.innerHTML = '';
        }
      }

      // Botón de medidas
      if (freshMeasures) {
        if (pageMeasures) {
          pageMeasures.replaceWith(freshMeasures);
        } else {
          viewer?.appendChild(freshMeasures);
        }
        if (!modal.dataset.sectionId && freshMeasures.dataset.sectionId) {
          modal.dataset.sectionId = freshMeasures.dataset.sectionId;
        }
      } else {
        // variante SIN imagen → quitar botón y cerrar modal si estaba abierto
        if (pageMeasures) {
  // Si quieres otra duración puntual: pageMeasures.style.setProperty('--tb-fade', '120ms');
  pageMeasures.classList.add('is-hiding');
  const dur = parseFloat(getComputedStyle(pageMeasures).transitionDuration) * 1000 || 120;
  setTimeout(() => pageMeasures.remove(), dur + 40); // pequeño margen
}
        if (modal.classList.contains('is-open')) {
          modal.classList.remove('is-open');
          document.body.classList.remove('tb-lock-scroll');
          modal.setAttribute('hidden', '');
        }
      }
    });

  } catch (e) {
    if (e.name === 'AbortError') return;
    console.error('Error refrescando #tb-measures:', e);
  }
}


// Listener original (lo mantenemos)
document
  .querySelector('variant-radios, variant-selects, form[action*="/cart/add"]')
  ?.addEventListener('change', () => {
    refreshTbMeasures();
  });

// Soporte adicional para eventos de tema: 'variant:change'
document.addEventListener('variant:change', (e) => {
  const vid = e?.detail?.variant?.id;
  if (vid) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', vid);
    history.replaceState({}, '', `${url.pathname}?${url.searchParams.toString()}`);
  }
  refreshTbMeasures();
});
